'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _reactRouterBootstrap = require('react-router-bootstrap');

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var internal = function internal(href, label) {
    return _react2.default.createElement(
        _reactRouterBootstrap.IndexLinkContainer,
        { key: href, to: href },
        _react2.default.createElement(
            _NavItem2.default,
            null,
            label
        )
    );
};

var external = function external(href, label) {
    return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
            'a',
            { href: href },
            label
        )
    );
};

var unclickable = function unclickable(label) {
    return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
            'a',
            {
                className: 'disabled',
                onClick: function onClick(e) {
                    return e.stopPropagation();
                } },
            label
        )
    );
};

var RailNavItem = function RailNavItem(_ref) {
    var item = _ref.item;

    var label = item.label;
    if ((0, _isString2.default)(item.path)) {
        return internal(item.path, label);
    }
    if ((0, _isString2.default)(item.externalHref)) {
        return external(item.externalHref, label);
    }
    return unclickable(label);
};

RailNavItem.propTypes = {
    item: _propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string,
        externalHref: _propTypes2.default.string
    }).isRequired
};

exports.default = RailNavItem;
//# sourceMappingURL=RailNavItem.js.map